import i18n from "../../i18n";

export function MandatoryType() {
    return Object.freeze({
        TRUE: { key: "TRUE", value: i18n.t("common.true") },
        FALSE: { key: "FALSE", value: i18n.t('common.false') },
        // DERIVED: { key: "DERIVED", value: "Derived" }
    });
}

export function InputType() {
    return Object.freeze({
        EMAIL: { key: "EMAIL", value: i18n.t('common.email') },
        PHONE: { key: "PHONE", value: i18n.t('common.phone') },
        PASSWORD: { key: "PASSWORD", value: i18n.t('common.password') },
        AGE: { key: "AGE", value: i18n.t('common.age') }
    });
}

export function QuestionType() {
    return Object.freeze({
        TEXT: { key: "TEXT", value: i18n.t('form.text') },
        CHOICE: { key: "CHOICE", value: i18n.t('form.choice') },
        CHECKBOX: { key: "CHECKBOX", value: i18n.t('form.checkbox') },
        NUMBER: { key: "NUMBER", value: i18n.t('form.number') },
        PERCENTAGE: { key: "PERCENTAGE", value: i18n.t('form.percentage') },
        STEPPER: { key: "STEPPER", value: i18n.t('form.stepper') },
        FILE: { key: "FILE", value: i18n.t('form.file') },
        ADDRESS: { key: "ADDRESS", value: i18n.t('form.address') },
        DATE: { key: "DATE", value: i18n.t('form.date') },
        DATE_TIME: { key: "DATE_TIME", value: i18n.t('form.date-time') },
        TIME: { key: "TIME", value: i18n.t('form.time') },
        DISPLAY: { key: "DISPLAY", value: i18n.t('form.display') },
        PHOTO: { key: "PHOTO", value: i18n.t('form.photo') },
        SIGNATURE: { key: "SIGNATURE", value: i18n.t('form.signature') },
        BUTTONS: { key: "BUTTONS", value: i18n.t('form.buttons') },
        SKU_SELECTION: { key: "SKU_SELECTION", value: i18n.t('form.sku-selection') },
        IMAGE_RECOGNITION: { key: "IMAGE_RECOGNITION", value: i18n.t('form.image-recognition') },
        STAR: { key: "STAR", value: i18n.t('form.star') },
        EQUIPMENT_SELECTION: { key: "EQUIPMENT_SELECTION", value: i18n.t('form.equipment-selection') },
        SCAN_BARCODE: { key: "SCAN_BARCODE", value: i18n.t('form.scan-barcode') },
        SCAN_EQUIPMENT: { key: "SCAN_EQUIPMENT", value: i18n.t('form.scan-equipment') },
        SCANNABLE_CUSTOMER_EQUIPMENT: { key: "SCANNABLE_CUSTOMER_EQUIPMENT", value: i18n.t('form.scannable-customer-equipment') }
    });
}

export function FormValueType() {
    return Object.freeze({
        BOOLEAN: { key: "BOOLEAN", value: i18n.t('form.boolean') },
        NUMBER: { key: "NUMBER", value: i18n.t('form.number') },
        TEXT: { key: "TEXT", value: i18n.t('form.text') },
        REGEX: { key: "REGEX", value: i18n.t('form.regex') },
        QUESTION_ID: { key: "QUESTION_ID", value: i18n.t('form.question-id') },
        NULL: { key: "NULL", value: i18n.t('form.null') }
    })
}

export function FormChildrenType() {
    return Object.freeze({
        FORM_GROUP: { key: "FORM_GROUP", value: i18n.t('form.form-group'), formType: "FormGroups" },
        QUESTION: { key: "QUESTION", value: i18n.t('form.question'), formType: "Questions" }
    })
}

export function FormType() {
    return Object.freeze({
        CALL_FLOW: { key: "Call Flow", value: i18n.t('form.call-flow') },
        TOOLBOX: { key: "Toolbox", value: i18n.t('form.briefcase') },
        // MAINMENU: { key: "MAINMENU", value: "Main Menu" }
    })
}
